// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Xi-md","nav":"Header_nav__KPhHB"};